import EditFormGroup from "components/form/EditFormGroup";
import { statusOption } from "pages/staff/StaffComponent";
import React, { forwardRef } from "react";

export default forwardRef(function DeliveryZoneForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "zone_name",
            label: "DELIVERY ZONE NAME",
            type: "text",
            required: true,
            size: "small",
            // itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
            fullWidth: true,
          },
          {
            name: "zone_postcodes",
            label: "INCLUDE POSTCODES",
            type: "multiline",
            placeholder: "Eg: 12345, 6789",
            required: true,
            size: "small",
            // itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
            fullWidth: true,
          },
          {
            name: "status",
            label: "STATUS",
            type: "native_select",
            options: statusOption,
            size: "small",
            // itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
            fullWidth: true,
          },
        ]}
        isLabel
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
